import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Projects from './components/Projects';
import Flagship from './components/Flagship';
import About from './components/About';
import Process from './components/Process';
import Lab from './components/Lab';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Preloader from './components/Preloader';
import ChatWidget from './components/ChatWidget';
import { AnimatePresence, motion } from 'framer-motion';

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // SECURITY: Disable right-click globally
    const handleContextMenu = (e) => {
      e.preventDefault();
    };

    window.addEventListener('contextmenu', handleContextMenu);

    const timer = setTimeout(() => {
      setLoading(false);
    }, 2500);

    return () => {
      window.removeEventListener('contextmenu', handleContextMenu);
      clearTimeout(timer);
    };
  }, []);

  return (
    <div className="min-h-screen bg-obsidian text-white selection:bg-neon-cyan selection:text-black">
      <AnimatePresence mode="wait">
        {loading ? (
          <motion.div 
            key="loader" 
            exit={{ opacity: 0, scale: 1.1 }} 
            transition={{ duration: 0.8, ease: "easeInOut" }} 
          >
            <Preloader />
          </motion.div>
        ) : (
          <motion.div 
            key="content" 
            initial={{ opacity: 0 }} 
            animate={{ opacity: 1 }} 
            transition={{ duration: 1 }} 
          >
            <Navbar />
            <Hero />
            <Projects />
            <Flagship />
            <Process />
            <About />
            <Lab />
            <Contact />
            <Footer />
            <ChatWidget />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;